const SectionDivisionReducer = (state = {}, action) => {
    switch (action.type) {
      case "SD_LISTVIEW":
        return Object.assign({}, state, {
          SD_ListView: action.data
        });
        case "SD_BLOCKNO":
          return Object.assign({}, state, {
            SD_BlockNumber: action.data
          });
      case "SDEDIT_DOCS":
        return Object.assign({}, state, {
          geteditsd: action.data
        });
      case "SD_DRAWING":
        return Object.assign({}, state, {
          SD_Drawing: action.data
        });
        case "SDEDIT_DRAWING":
          return Object.assign({}, state, {
            SDEDIT_Drawing: action.data
          });
      default:
        return state;
    }
  };
  
  export default SectionDivisionReducer;
  
  